import { QueryClient } from '@tanstack/react-query';

// Aggressive caching defaults. The wiki is read-heavy and the materializer keeps S3
// in sync, so we want React Query to:
//   - return cached data instantly
//   - revalidate in background after a stale window
//   - never refetch on window focus (annoying for a wiki)

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 minute — tree.json refreshes if older
      gcTime: 30 * 60_000, // 30 minutes
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});
